import privacyMarkdown from '@/content/privacy.md?raw';
import { parsePrivacyMarkdown } from '@/content/parse-privacy-markdown';
import type { PrivacyTocEntry } from '@/content/privacy.types';

// Source: Mainstage Legal, Privacy Policy tab (July 22, 2026).
// https://docs.google.com/document/d/1UNVgTrqXkLmgj-Zb4G_3t-iUDARb0nNm8KaMyhkV-iw/edit?tab=t.n90bo5hh42wt
// Preserve the supplied wording in privacy.md; only presentation is handled here.
export const privacyBlocks = parsePrivacyMarkdown(privacyMarkdown);

export const privacyToc: PrivacyTocEntry[] = privacyBlocks.flatMap((block) =>
  block.kind === 'heading' && (block.level === 2 || block.level === 3) && block.id
    ? [{ id: block.id, text: block.text, level: block.level }]
    : [],
);
